import { UploadedMediaResponse, UploadMediaParams } from '../../lib/types/models/media/media'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function uploadMedia({ file, folder }: UploadMediaParams) {
  if (file.startsWith('https')) return file.substring(file.indexOf('.com/') + 5)
  const blob = await fetch(file).then((r) => r.blob())
  const mimeType = blob.type
  const extension = mimeType.split('/')[1]

  const response = await restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.media.getMediaPath.url, null), {
        path: folder,
        fileName: `${Math.random().toString(36).substring(7)}.${extension}`
      })
    )
    .get<UploadedMediaResponse>()

  if (!response) throw new Error(':( No URL found.')

  await fetch(response.url, { method: 'put', body: blob })

  return response.path
}
